import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-event-enable",
  "use": "app-icon-event-enable-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-event-enable\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#686868\" stroke-width=\"1.5\" d=\"M2.75.75h10.5v13.5H2.75z\" /><g fill=\"#686868\"><path d=\"M5 7h6v1.2H5zM5 10.5h6v1.2H5zM5 3.5h6v1.2H5z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol